module.exports = __webpack_public_path__ + "static/img/5.bf9f09b7.png";